module.exports = __webpack_public_path__ + "components/flag/static/square/kz-1d8d78b8afe40c6f139ce9616e22bc50.svg";